import request from './request'

export function listMachine(data) {
  return request.post('/mes/machines/list', data)
}
export function selectMachine() {
  return request.get('/mes/machines/select')
}
export function getMachine(id) {
  return request.get('/mes/machines/' + id)
}
export function saveMachine(data) {
  return request.post('/mes/machines', data)
}
export function updateMachine(data) {
  return request.post('/mes/machines/update', data)
}
export function deleteMachine(ids) {
  return request.post('/mes/machines/delete', ids)
}
